import moment from 'moment';

export function parseUser(account){
    return {
        id: account.id,
        site_id: account.site_id,
        first_name: account.first_name,
        last_name: account.last_name,
        phone: account.phone,
        status: account.status,
        email: account.email,
        client_id: account.client_id,
        updated_at: account.updated_at,
        role: account.role,
    }
}

export function parseClient(account){
    return {
        id: account.id,
        name: account.name,
        account_number: account.account_number,
        group_id: account.group_id,
        users_count: account.users_count,
    }
}

export function parseEquipment(item){
    let location = [item.O_LOCALE, `${item.O_ADDRESS1} ${item.O_ADDRESS2}`, item.O_SUBURB, item.O_CITY]
        /*.filter(function (item) {
            return item != 'null' && item != 'null null' && item != 'null null null';
        })*/
        .filter(Boolean)
        .map(function(item){
            return item.replaceAll('null', '').trim()
        })
        .join(', ');

    return {
        id: item.WAR_ID,
        client_name: item.CLIENT_1_NAME,
        type: item.MAKE,
        model: item.MODEL,
        location: location,
        serial: item.SERIAL,
        img: item.PROD_IMAGE_URL ? item.PROD_IMAGE_URL : '',
        order_number_required: item.ON_REQUIRED == "Y",
        consumable_fee_amount: item.CONSUMABLE_FEE_AMOUNT,
        consumable_fee_des: item.CONSUMABLE_FEE_DES,
    }
}


export function parseConsumable(item){
    return {
        id: item.STOCK_ID,
        part_number: item.PART_NUMBER,
        price: item.SALE_VALUE,
        description: item.DES_1,
        img: item.IMAGE_URL,
        colour: item.COLOUR,
        selected: false
    }
}

export function parseMeterReading(item) {
    return {
        id: item.METER_ID,
        name: item.METER_NAME,
        last_value: item.LAST_VALUE,
        last_read_date: moment(item.LAST_READ_DATE),
        new_value: null
    }
}
